import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

// Pages
import NewShare from './pages/NewShare'
import ViewShare from './pages/ViewShare'
import PageNotFound from './pages/PageNotFound'

const routes = [NewShare, ViewShare, PageNotFound]

const AppRouter = () => (
    <Router>
        <Switch>
            {routes.map((route, idx) => (
                <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    component={route.component}
                />
            ))}
        </Switch>
    </Router>
)

export default AppRouter



// WEBPACK FOOTER //
// ./src/router.js